<template>
  <section class="topbar-four">
    <!-- MOBILE HEADER - Cotação e Idioma -->
    <div class="topbar-mobile-header d-flex d-md-none">
      <div class="topbar-mobile-left">
        <!-- Cotação -->
        <div class="topbar-four__info__currency">
          <button class="currency-toggle-button" @click.stop="toggleCurrencyDropdownMobile">
            <i class="flaticon-dollar"></i>
            <span>{{ t('exchange') }}</span>
            <i class="fas fa-chevron-down" style="margin-left: 5px;"></i>
          </button>
          <transition name="dropdown-fade">
            <div v-if="currencyDropdownMobileVisible" class="topbar-dropdown">
              <template v-if="currencies.length">
                <div v-for="currency in currencies" :key="currency.target_currency.id" class="dropdown-item">
                  <img v-if="currency.target_currency.symbol === 'R$'" src="@/assets/images/bandeira-brasil.webp"
                    alt="Brasil" class="flag-icon" />
                  <img v-if="currency.target_currency.symbol === 'G$'" src="@/assets/images/bandeira-paraguai.webp"
                    alt="Paraguai" class="flag-icon" />
                  {{ currency.target_currency.symbol }}
                  {{ formatTax(currency.tax, currency.target_currency.decimals) }}
                </div>
              </template>
              <template v-else>
                <span>{{ t('loading') }}</span>
              </template>
            </div>
          </transition>
        </div>
      </div>

      <div class="topbar-mobile-right">
        <!-- Idioma -->
        <div class="topbar-four__info__language">
          <button class="language-toggle-button" @click.stop="toggleLanguageDropdownMobile">
            <img :src="$i18n.locale === 'pt-BR'
              ? require('@/assets/images/bandeira-brasil.webp')
              : require('@/assets/images/bandeira-paraguai.webp')
              " alt="Flag" class="flag-icon" />
            <i class="fas fa-chevron-down" style="margin-left: 5px;"></i>
          </button>
          <transition name="dropdown-fade">
            <div v-if="languageDropdownMobileVisible" class="topbar-dropdown">
              <button @click="changeLanguage('pt-BR')" class="dropdown-item">
                <img src="@/assets/images/bandeira-brasil.webp" alt="Português" class="flag-icon" />
                {{ t('language.pt') }}
              </button>
              <button @click="changeLanguage('es-PY')" class="dropdown-item">
                <img src="@/assets/images/bandeira-paraguai.webp" alt="Español" class="flag-icon" />
                {{ t('language.es') }}
              </button>
            </div>
          </transition>
        </div>
      </div>
    </div>


    <div class="container">
      <div class="topbar-four__inner">
        <!-- Logo -->
        <div class="topbar-four__logo">
          <a href="/">
            <img src="@/assets/images/logo.png" alt="Karoons HTML" width="350" />
          </a>
        </div>

        <!-- Campo de busca -->
        <div class="topbar-four__search">
          <form @submit.prevent="searchProducts" class="d-flex">
            <input v-model="searchText" @input="debouncedHandleInput" @focus="showSuggestions = true" @blur="handleBlur"
              type="search" class="search-input" :placeholder="searchPlaceholder" autocomplete="off" />
            <button type="submit">
              <i class="flaticon-search"></i>
            </button>
          </form>
        </div>

        <!-- Informações -->
        <ul class="list-unstyled topbar-four__info d-none d-md-flex align-items-center gap-4">
          <!-- Cotação -->
          <li>
            <div class="topbar-four__info__currency" @mouseenter="showDropdown" @mouseleave="hideDropdown">
              <button class="currency-toggle-button">
                <i class="flaticon-dollar"></i>
                <span class="d-none d-md-inline">{{ t('exchange') }}</span>
                <i class="fas fa-chevron-down" style="margin-left: 5px;"></i>
              </button>
              <transition name="dropdown-fade">
                <div class="topbar-dropdown" v-show="isDropdownVisible" @mouseenter="keepDropdownVisible"
                  @mouseleave="hideDropdown">
                  <template v-if="currencies.length">
                    <div v-for="currency in currencies" :key="currency.target_currency.id" class="dropdown-item">
                      <img v-if="currency.target_currency.symbol === 'R$'" src="@/assets/images/bandeira-brasil.webp"
                        alt="Brasil" class="flag-icon" />
                      <img v-if="currency.target_currency.symbol === 'G$'" src="@/assets/images/bandeira-paraguai.webp"
                        alt="Paraguai" class="flag-icon" />
                      {{ currency.target_currency.symbol }}
                      {{ formatTax(currency.tax, currency.target_currency.decimals) }}
                    </div>
                  </template>
                  <template v-else>
                    <span>{{ t('loading') }}</span>
                  </template>
                </div>
              </transition>
            </div>
          </li>


          <!-- Idioma -->
          <li class="topbar-four__info__language">
            <button class="language-toggle-button" @click.stop="toggleLanguageDropdownDesktop">
              <img :src="$i18n.locale === 'pt-BR'
                ? require('@/assets/images/bandeira-brasil.webp')
                : require('@/assets/images/bandeira-paraguai.webp')" alt="Flag" class="flag-icon" />
              <span class="d-none d-md-inline">
                {{ t(`language.${$i18n.locale === 'pt-BR' ? 'pt' : 'es'}`) }}
              </span>
              <i class="fas fa-chevron-down" style="margin-left: 5px;"></i>
            </button>

            <transition name="dropdown-fade">
              <div v-if="languageDropdownDesktopVisible" ref="languageDropdownRef" class="topbar-dropdown">
                <button @click="changeLanguage('pt-BR')" class="dropdown-item">
                  <img src="@/assets/images/bandeira-brasil.webp" alt="Português" class="flag-icon" />
                  {{ t('language.pt') }}
                </button>
                <button @click="changeLanguage('es-PY')" class="dropdown-item">
                  <img src="@/assets/images/bandeira-paraguai.webp" alt="Español" class="flag-icon" />
                  {{ t('language.es') }}
                </button>
              </div>
            </transition>
          </li>


          <!-- Login ou Perfil -->
          <li>
            <a v-if="!isAuthenticated" href="/login" class="topbar-button icon-only">
              <i class="fas fa-user"></i>
            </a>
            <a v-else href="/perfil" class="topbar-button icon-only">
              <i class="fas fa-user"></i>
            </a>
          </li>

          <!-- Carrinho -->
          <li>
            <a @click.prevent="openCart" class="topbar-button icon-only">
              <i class="fas fa-shopping-cart"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <!-- Botões mobile abaixo da barra de pesquisa -->
    <div class="mobile-buttons-container d-flex d-md-none justify-content-between container">
      <!-- Login Mobile -->
      <a v-if="!isAuthenticated" href="/login" class="mobile-icon">
        <i class="fas fa-user"></i>
      </a>
      <a v-else href="/perfil" class="mobile-icon">
        <i class="fas fa-user"></i>
      </a>
      
      <!-- Carrinho Mobile -->
      <a @click.prevent="openCart" class="mobile-icon">
        <i class="fas fa-shopping-cart"></i>
      </a>
    </div>

    <!-- WhatsApp fixo -->
    <div class="whatsapp-icon">
      <a href="https://wa.me/554598396933" target="_blank" rel="noopener noreferrer">
        <img src="@/assets/images/whatsapp-icon.png" alt="WhatsApp" />
      </a>
    </div>
  </section>
</template>

<script setup>
import { ref, watch, onMounted, onUnmounted, computed, getCurrentInstance } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { fetchExchangeRates } from '@/services/apiService';
import { eventBus } from '@/eventBus';

const languageDropdownMobileVisible = ref(false)
const languageDropdownDesktopVisible = ref(false)
const currencyDropdownMobileVisible = ref(false);

const store = useStore();
const router = useRouter();
const route = useRoute();
const { t } = useI18n();
const { appContext } = getCurrentInstance();
const $i18n = appContext.config.globalProperties.$i18n;
const toggleCurrencyDropdownMobile = () => {
  currencyDropdownMobileVisible.value = !currencyDropdownMobileVisible.value;
}
const toggleLanguageDropdownDesktop = () => {
  languageDropdownDesktopVisible.value = !languageDropdownDesktopVisible.value
}

const toggleLanguageDropdownMobile = () => {
  languageDropdownMobileVisible.value = !languageDropdownMobileVisible.value
}

const searchText = ref('');
const showSuggestions = ref(false);
const currencies = ref([]);
const isDropdownVisible = ref(false);
const languageDropdownRef = ref(null);
const screenWidth = ref(window.innerWidth);

const user = computed(() => store.getters['auth/getUser']);
const isAuthenticated = computed(() => store.getters['auth/isAuthenticated']);
const userNome = computed(() => user.value?.nome || t('greeting'));

const searchPlaceholder = computed(() => {
  return screenWidth.value <= 767
    ? t('search.placeholderMobile')
    : t('search.placeholderDesktop');
});
const handleClickOutsideLanguageMobile = (event) => {
  const dropdown = document.querySelector('.topbar-mobile-header .topbar-four__info__language')
  if (dropdown && !dropdown.contains(event.target)) {
    languageDropdownMobileVisible.value = false
  }
}
const handleClickOutsideCurrencyMobile = (event) => {
  const dropdown = document.querySelector('.topbar-mobile-header .topbar-four__info__currency')
  if (dropdown && !dropdown.contains(event.target)) {
    currencyDropdownMobileVisible.value = false
  }
}


const updateScreenWidth = () => {
  screenWidth.value = window.innerWidth;
};

const debounce = (func, delay) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), delay);
  };
};
const debouncedHandleInput = debounce(() => { }, 300);
const debouncedUpdateScreen = debounce(updateScreenWidth, 100);

const formatTax = (tax, decimals) => {
  const number = parseFloat(tax);
  return decimals === 0
    ? number.toLocaleString('es-PY')
    : number.toFixed(decimals).replace('.', ',');
};

const searchProducts = () => {
  if (searchText.value.trim()) {
    router.push({ name: 'produtos', query: { text: searchText.value } });
  }
};

const openCart = () => {
  eventBus.emit('toggle-cart');
};

const handleBlur = () => {
  setTimeout(() => {
    if (!document.querySelector('.topbar-four__search:hover')) {
      showSuggestions.value = false;
    }
  }, 200);
};

const showDropdown = () => (isDropdownVisible.value = true);
const hideDropdown = () => (isDropdownVisible.value = false);
const keepDropdownVisible = () => (isDropdownVisible.value = true);

const handleClickOutsideLanguageDesktop = (event) => {
  const dropdown = document.querySelector('.topbar-four__info__language');
  if (dropdown && !dropdown.contains(event.target)) {
    languageDropdownDesktopVisible.value = false;
  }
};


const changeLanguage = (newLocale) => {
  if ($i18n.locale === newLocale) return;

  localStorage.setItem('locale', newLocale);
  store.commit('language/setLanguage', newLocale);
  store.dispatch('ecommerce/getCart');

  window.location.reload();
};



onMounted(async () => {
  updateScreenWidth();
  window.addEventListener('resize', debouncedUpdateScreen);
  document.addEventListener('click', handleClickOutsideLanguageDesktop);
  document.addEventListener('click', handleClickOutsideLanguageMobile)
  document.addEventListener('click', handleClickOutsideCurrencyMobile)

  try {
    currencies.value = await fetchExchangeRates();
  } catch (error) {
    console.error('Erro ao carregar cotações:', error);
  }
});

onUnmounted(() => {
  window.removeEventListener('resize', debouncedUpdateScreen);
  document.removeEventListener('click', handleClickOutsideLanguageMobile)
  document.removeEventListener('click', handleClickOutsideCurrencyMobile)

});

watch(
  () => route.query.text,
  (newText, oldText) => {
    if (newText !== oldText) {
      searchText.value = newText || '';
    }
  }
);
</script>

<style>
/* Cabeçalho mobile */
.topbar-mobile-header {
  width: 100%;
  background-color: #fff;
  padding: 10px 15px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
}

.topbar-mobile-left,
.topbar-mobile-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mobile-buttons-container {
  padding: 0 15px;
  margin-top: -25px;
}

.mobile-icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  color: #333;
  text-decoration: none;
  background-color: transparent;
  transition: color 0.3s ease;
}

.mobile-icon:hover {
  color: #ff6600;
}

.topbar-mobile-header .currency-toggle-button,
.topbar-mobile-header .language-toggle-button {
  gap: 6px;
  font-size: 13px;
  white-space: nowrap;
}



.search-input::placeholder {
  font-size: 16px;
  color: #888787;
}

.topbar-four__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.topbar-four__logo {
  flex-shrink: 0;
}

.topbar-four__search {
  flex-grow: 2.5;
  margin: 0 2px;
}

.topbar-four__info {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: auto;
  flex-shrink: 0;
}

.topbar-button,
.language-toggle-button,
.currency-toggle-button {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: #333;
  text-decoration: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 4px;
  justify-content: center;
  line-height: 1;
  transition: background 0.3s ease, color 0.3s ease;
}

.topbar-button.icon-only {
  width: 32px;
  height: 32px;
  padding: 0;
  justify-content: center;
  align-items: center;
  font-size: 20px;
}

.topbar-button:hover,
.language-toggle-button:hover,
.currency-toggle-button:hover {
  background-color: #f5f5f5;
  color: #ff6600;
}

.topbar-dropdown {
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 6px;
  background-color: #fff;
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  min-width: 160px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
}

.dropdown-item {
  width: 100%;
  background: none;
  border: none;
  padding: 14px 16px;
  margin-bottom: 10px;
  text-align: left;
  font-size: 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  border-radius: 6px;
}


.dropdown-item:last-child {
  margin-bottom: 0;
}

.dropdown-item:hover {
  background-color: #f0f0f0;
  color: #333;
}

.flag-icon {
  width: 16px;
  height: auto;
  object-fit: cover;
}

.topbar-four__info__currency,
.topbar-four__info__language {
  position: relative;
}

.language-toggle-button:hover {
  color: #ff6600;
}

@media (max-width: 576px) {

  .language-toggle-button span {
   
  }

  .currency-toggle-button span {}

  .topbar-dropdown {
    left: auto;
    right: 0;
    min-width: 180px;
  }

  .topbar-four__search {
    margin: 0 10px;
  }

  .topbar-button.icon-only {
    width: 28px;
    height: 28px;
  }
}

.topbar-four__info__currency .topbar-dropdown {
  left: 0 !important;
  right: auto !important;
  transform: translateX(0);
  /* força o dropdown a alinhar à esquerda */
  min-width: 180px;
}

.topbar-four__info li {
  list-style: none;
}

.whatsapp-icon {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
  width: 50px;
  height: 50px;
  background-color: #0FC043;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.whatsapp-icon img {
  width: 40px;
  height: auto;
}

@media (max-width: 576px) {
  .topbar-button.icon-only {
    width: 36px;
    height: 36px;
  }

  .topbar-button.icon-only i {
    font-size: 18px;
  }
}
</style>
